import type { DeepPartial } from '@luna/utils-ts';

import type {
    SharedShorthandTransactionsFeatures,
    SharedTransactionsFeatures,
} from '../../types/SharedTransactionsFeatures';

export const features: DeepPartial<SharedTransactionsFeatures> = {
    productStatementFilter: {
        enabled: true,
    },
    globalStatementFilter: {
        enabled: false,
    },
    startingAndEndingBalance: {
        enabled: true,
    },
};

export const shorthandFeatures: DeepPartial<SharedShorthandTransactionsFeatures> = {};
